import React, { Component } from "react";
import { Wrapper } from './style.js';
import Close from '~/assets/close-outline.png';

class PopupChat extends Component {

    state = {
        current_step: null,
        steps : [
            {
                step: 1,
                title: "Conheça o nosso novo chat!",
                description: "Este é um espaço onde você pode tirar suas dúvidas e até mesmo entrar em contato com um dos nossos antendentes.",
                buttons: ["jump","next"]
            },
            {
                step: 2,
                title: "Está com dúvidas?",
                description: "Não sabe onde procurar determinada informação? Digite no nosso chat ele te mostrará o caminho para obter as respostas.",
                buttons: ["jump","next"]
            },
            {
                step: 3,
                title: "Precisa de ajuda especifica?",
                description: "Com o chat você pode também falar com um antendente em tempo real, caso não ache aquilo que está buscando não exite buscar nossa ajuda!",
                buttons: ["close"]
            }
        ],
        show_popup: true
    }

    componentDidMount() {
        //window.localStorage.removeItem('popup_chat');
        let popup_chat = window.localStorage.getItem('popup_chat')
        if ( popup_chat ) {
            window.document.getElementsByClassName('popup-chat-component')[0].style.display = 'none'
            this.state.show_popup = false
        }
        this.loadStep(1)
    }

    componentDidUpdate() {

    }

    loadStep(step) {
        let step_obj = this.state.steps.filter(step_item => step_item.step == step)
        this.setState({current_step: {...step_obj[0]}})
    }

    closePopup() {
        window.document.getElementsByClassName('popup-chat-component')[0].style.display = 'none'
        window.localStorage.setItem("popup_chat","done")
        this.state.show_popup = false
    }

    nextPopup() {
        let next = this.state.current_step.step + 1
        this.loadStep(next)
    }

    render() {
        let steps = this.state.steps
        return (
            <Wrapper className="popup-chat-component">

                {this.state.show_popup && (
                    <>
                        <img className="close-button" src={Close} onClick={()=>{this.closePopup()}}/>

                        { this.state.current_step && (
                            <div className="step">
                                <h3 className="title-step">{this.state.current_step.title}</h3>
                                <div className="description-step">{this.state.current_step.description}</div>
                                <div className="buttons">
                                    { this.state.current_step.buttons.indexOf("jump") != -1 && (
                                        <button onClick={()=>{this.closePopup()}} className="jump">Pular</button>
                                    ) }

                                    { this.state.current_step.buttons.indexOf("next") != -1 && (
                                        <button onClick={()=>{this.nextPopup()}} className="next">Avançar</button>
                                    ) }

                                    { this.state.current_step.buttons.indexOf("close") != -1 && (
                                        <button onClick={()=>{this.closePopup()}} className="close">Fechar</button>
                                    ) }
                                </div>
                            </div>
                        ) }
                    </>
                )}
                
            </Wrapper>
        )
    }
}

export default PopupChat;